import { useEffect, useState } from 'react';
import { contentService } from '../../../services';

export default function useVideosDomain() {
  const [videoGenerating, setVideoGenerating] = useState(false);
  const [videoProgress, setVideoProgress] = useState('');
  const [generatedVideo, setGeneratedVideo] = useState(null);
  const [myVideos, setMyVideos] = useState([]);
  const [loadingVideos, setLoadingVideos] = useState(false);

  const fetchMyVideos = async () => {
    try {
      setLoadingVideos(true);
      const data = await contentService.myVideos();
      if (data.success) {
        setMyVideos(data.videos || []);
      }
    } catch (error) {
      console.error('Erro ao buscar vídeos:', error);
    } finally {
      setLoadingVideos(false);
    }
  };

  useEffect(() => {
    fetchMyVideos();
  }, []);

  return {
    videoGenerating,
    setVideoGenerating,
    videoProgress,
    setVideoProgress,
    generatedVideo,
    setGeneratedVideo,
    myVideos,
    loadingVideos,
    fetchMyVideos
  };
}
